import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { useAuth } from '@/contexts/auth-context';
import { queryKeys } from '@/lib/query-client';

const STAFFING_BOARD_PRESENCE_API = '/api/v1/staffing-board/heartbeat/';
const BOARD_PRESENCE_REFETCH_INTERVAL = 20_000;

export interface BoardPresenceViewer {
  user_id: number;
  name: string;
  initials: string;
  last_seen: string;
}

interface BoardPresenceResponse {
  viewers: BoardPresenceViewer[];
}

export function useBoardPresence() {
  const { user } = useAuth();
  const organizationId = user?.organization ?? null;
  const userId = user?.id ?? null;

  return useQuery<BoardPresenceResponse, Error, BoardPresenceViewer[]>({
    queryKey: queryKeys.boardPresence.detail(organizationId ?? 0, userId ?? 0),
    enabled: organizationId != null && userId != null,
    queryFn: async () => {
      const response = await apiClient.post<BoardPresenceResponse>(STAFFING_BOARD_PRESENCE_API, {});
      return response.data;
    },
    select: (data) => data.viewers.filter((viewer) => viewer.user_id !== userId),
    refetchInterval: BOARD_PRESENCE_REFETCH_INTERVAL,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
}
